<template>
  <div
    class="site_wrapper"
    :class="page"
  >
    <page-header />
    <main class="site_content">
      <router-view />
    </main>
    <page-footer />
    <page-loader :is-modal-open="showPageLoaderGetter" />
    <div
      v-if="toastsGetter.length"
      id="toast-box"
      aria-live="polite"
      aria-atomic="true"
    >
      <toast
        v-for="toast in toastsGetter"
        :key="toast.published_at"
        :message="toast.message"
        :variant="toast.variant"
        :title="toast.title"
        :delay="toast.delay"
      />
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import PageHeader from '~layouts/Header'
import PageFooter from '~layouts/Footer'
import Toast from '~components/third-party/bootstrap/Toast'
import PageLoader from '~components/common/modal/PageLoader'
export default {
  name: 'PagesLayout',
  components: {
    PageHeader,
    PageFooter,
    Toast,
    PageLoader
  },
  props: {
    page: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters('layouts', [
      'toastsGetter',
      'showPageLoaderGetter'
    ])
  }
}
</script>
<style lang="scss" scoped>
#toast-box {
  position: fixed;
  top: 0.75rem;
  right: 0.75rem;
  z-index: 1010;
  width: 300px;
  max-height: 100vh;
  overflow: auto;
  transition: ease-in-out;
  height: auto;
}
</style>
